import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../components/common/Logo';
import Sidebar from '../../components/patient/PatientSidebar';
import AppointmentService from '../../services/appoinment.service';

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  const [isRestoring, setIsRestoring] = useState(true);
  
  useEffect(() => {
    const restoreSuggestedStatus = async () => {
      try {
        // Controlla se c'era un pagamento pending per un appuntamento suggested
        const pendingPaymentStr = sessionStorage.getItem('pendingPayment');
        
        if (pendingPaymentStr) {
          const pendingPayment = JSON.parse(pendingPaymentStr);
          
          // Se era un appuntamento suggested, ripristina lo status
          if (pendingPayment.wasSuggested && pendingPayment.appointmentId) {
            console.log('Ripristino status suggested per appuntamento:', pendingPayment.appointmentId);
            
            await AppointmentService.updateStatus(
              pendingPayment.appointmentId,
              'suggested'
            );
            
            console.log('Status ripristinato a suggested con successo');
          }
          
          // Rimuovi l'informazione dal sessionStorage
          sessionStorage.removeItem('pendingPayment');
        }
      } catch (error) {
        console.error('Errore durante il ripristino dello status:', error);
      } finally {
        setIsRestoring(false);
      }
    };
    
    restoreSuggestedStatus();
  }, []);
  
  if (isRestoring) {
    return (
      <div className="flex min-h-screen">
        <div className="w-64 bg-white shadow-md">
          <div className="p-4">
            <Logo />
          </div>
          <Sidebar />
        </div>
        <div className="flex-1 p-8 bg-[#FAF4EB] flex items-center justify-center">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500"></div>
            <p className="mt-2 text-gray-600">Elaborazione in corso...</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <Sidebar />
      </div>
      
      <div className="flex-1 p-8 bg-[#FAF4EB] flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md w-full">
          <div className="w-20 h-20 bg-yellow-100 rounded-full mx-auto mb-6 flex items-center justify-center">
            <svg className="w-10 h-10 text-yellow-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-yellow-700 mb-4">Pagamento annullato</h2>
          <p className="text-gray-600 mb-6">
            Il processo di pagamento è stato interrotto. Nessun addebito è stato effettuato sulla tua carta.
          </p>
          <div className="flex flex-col space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="w-full bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700"
            >
              Riprova il pagamento
            </button>
            <button
              onClick={() => navigate('/patient/dashboard')}
              className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded hover:bg-gray-200"
            >
              Torna alla Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;